<template>
  <div
    class="mb-56 flex justify-center px-24 md:mx-auto md:max-w-[736px] md:px-0"
  >
    <div class="max-w-full grow">
      <p class="body-1-bold">{{ summary }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    summary?: string
  }>(),
  {
    summary: '',
  },
)
</script>
